export default __webpack_public_path__ + "static/media/4-2_image13@2x.ad4877e5.png";